import { createPaymentCheckout } from '@/api/create-payment-checkout.ts'
import { usePaymentControllerChecksPaymentSubscriptionStatus } from '@/api/generated/okami.ts'
import { Button } from '@/components/ui/button.tsx'
import { isCancelledError, useMutation } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { ArrowRight, Loader2 } from 'lucide-react'
import { useCallback, useEffect } from 'react'
import { toast } from 'sonner'

export const Route = createFileRoute('/_app/payment/checkout')({
  component: Checkout,
})

function Checkout() {
  const navigate = Route.useNavigate()

  const { mutateAsync: createCheckout, isPending: isCreatingCheckout } = useMutation({
    mutationFn: createPaymentCheckout,
    mutationKey: ['createPaymentCheckout'],
  })

  const {
    refetch: checksSubscriptionStatus,
    isPending,
    data,
  } = usePaymentControllerChecksPaymentSubscriptionStatus({
    query: { enabled: false },
  })

  const showLoading = isCreatingCheckout || isPending

  const createPaymentCheckoutHandler = useCallback(async () => {
    try {
      const { data: userSubscription } = await checksSubscriptionStatus({ throwOnError: true })

      if (userSubscription?.isActive) {
        toast.warning('Você já possui uma assinatura ativa')

        return
      }

      const { paymentSessionId } = await createCheckout()

      window.location.replace(paymentSessionId)
    } catch (error) {
      if (!isCancelledError(error)) {
        toast.error('Erro ao verificar assinatura ativa')
      }
    }
  }, [])

  useEffect(() => {
    void createPaymentCheckoutHandler()
  }, [createPaymentCheckoutHandler])

  return (
    <div className="flex items-center justify-center">
      {data?.isActive && (
        <div className="flex flex-col items-center justify-center gap-4">
          <h2 className="text-2xl text-foreground">Tudo certo !</h2>
          <p className="text-muted-foreground">Você já possui uma assinatura ativa.</p>
          <Button variant="outline" onClick={() => navigate({ to: '/', replace: true })}>
            <ArrowRight className="size-4 text-muted-foreground mr-2" />
            Voltar para o Dashboard
          </Button>
        </div>
      )}

      {showLoading && <Loader2 className="size-32 animate-spin" />}
      {!data?.isActive && !showLoading && <p>Redirecionando...</p>}
    </div>
  )
}
